import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04bfc776"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex" }
const _hoisted_2 = { class: "p-offset-2" }
const _hoisted_3 = { class: "p-offset-4 p-col-3 app-legend" }
const _hoisted_4 = { class: "p-offset-2" }
const _hoisted_5 = { class: "p-offset-2" }
const _hoisted_6 = { class: "p-mb-6" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode()
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 0,
  class: "p-offset-2"
}
const _hoisted_24 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_25 = { class: "p-field p-col-2" }
const _hoisted_26 = { class: "p-field p-col-2" }
const _hoisted_27 = {
  key: 1,
  class: "p-offset-2"
}
const _hoisted_28 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_29 = { class: "p-field p-col-2" }
const _hoisted_30 = { class: "p-field p-col-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_form_legend = _resolveComponent("form-legend")!
  const _component_site_form = _resolveComponent("site-form")!
  const _component_fungus_record_form = _resolveComponent("fungus-record-form")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (['editingUnsaved', 'editing'].includes(_ctx.$store.state.formState) && _ctx.$store.state.menubarClicked)
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 0,
            closable: false,
            severity: "warn"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('form.unsaved_changes')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('new_record')), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_form_legend, {
            collapsed: true,
            "legend-items": [{name:'required', styleClass:'required'},{name:'notRequired', styleClass:'notRequired'},{name:'pError', styleClass:'pError'}],
            toggleable: true,
            "legend-info": true,
            "legend-subtitle": true
          })
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('form.site')), 1)
      ]),
      _createElementVNode("div", null, [
        (_ctx.fungusRecordForm.site.length > 0)
          ? (_openBlock(), _createBlock(_component_site_form, {
              key: 0,
              config: _ctx.fungusRecordForm.site
            }, null, 8, ["config"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('form.records')), 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fungusRecordForm.records, (record, key) => {
            return (_openBlock(), _createBlock(_component_fungus_record_form, {
              key: key,
              record: record,
              "record-idx": key
            }, null, 8, ["record", "record-idx"]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", null, [
        (_ctx.state === 'error')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.$store.state.errors), (msg, key) => {
                return (_openBlock(), _createElementBlock("div", { key: key }, [
                  (msg !== 'records')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_Message, {
                          severity: "error",
                          closable: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('help.' + msg + 'Title')) + " ", 1),
                            _hoisted_9,
                            _createTextVNode(" " + _toDisplayString(_ctx.$store.state.errors[msg]), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              (Object.keys(_ctx.$store.state.errors).includes('records') && typeof _ctx.$store.state.errors['records'] === 'object')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.$store.state.errors.records), (record, idx) => {
                      return (_openBlock(), _createElementBlock("div", { key: idx }, [
                        _createVNode(_component_Message, {
                          severity: "error",
                          closable: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('form.species_record') + ' ') + " " + _toDisplayString(parseInt(record) + 1), 1),
                            _hoisted_11,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.errors.records[record], (i, errorField) => {
                              return (_openBlock(), _createElementBlock("span", { key: i }, [
                                _createTextVNode("   - '" + _toDisplayString(_ctx.$t('help.' + errorField + 'Title')) + "' : ", 1),
                                (typeof i === 'string')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(i), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(i, (x, no) => {
                                        return (_openBlock(), _createElementBlock("span", { key: x }, [
                                          _hoisted_14,
                                          _createTextVNode("       - N. " + _toDisplayString(parseInt(no) + 1) + " : ", 1),
                                          _hoisted_15,
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(x, (el, ix) => {
                                            return (_openBlock(), _createElementBlock("span", { key: el }, [
                                              _createTextVNode("         '" + _toDisplayString(_ctx.$t('help.' + ix + 'Title')) + "' : " + _toDisplayString(el), 1),
                                              _hoisted_16
                                            ]))
                                          }), 128))
                                        ]))
                                      }), 128)),
                                      _hoisted_17,
                                      _hoisted_18
                                    ])),
                                _hoisted_19
                              ]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    }), 128))
                  ]))
                : (Object.keys(_ctx.$store.state.errors).includes('records') && typeof _ctx.$store.state.errors['records'] === 'string')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createVNode(_component_Message, {
                        closable: true,
                        severity: "error"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('form.empty_record_list')) + " ", 1),
                          _hoisted_21,
                          _createTextVNode(" " + _toDisplayString(_ctx.$store.state.errors['records']), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", null, [
      (_ctx.submitAnswer.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            (_ctx.submitAnswer === 'error')
              ? (_openBlock(), _createBlock(_component_Message, {
                  key: 0,
                  severity: "error",
                  closable: true
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.submitAnswer), 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_Message, {
                  key: 1,
                  severity: "success",
                  closable: true
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.submitAnswer), 1)
                  ]),
                  _: 1
                }))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      (_ctx.cancelRequested)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createVNode(_component_Message, {
              severity: "warn",
              closable: true
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('form.delete_question')), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_Button, {
                  class: "p-button-primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancelRequested = false)),
                  label: _ctx.$t('form.keep')
                }, null, 8, ["label"])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_Button, {
                  class: "p-button-danger",
                  onClick: _ctx.cancel,
                  label: _ctx.$t('delete')
                }, null, 8, ["onClick", "label"])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_Button, {
                  class: "p-button-danger",
                  icon: "pi pi-trash",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancelRequested = true)),
                  label: _ctx.$t('form.discard')
                }, null, 8, ["label"])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_Button, {
                  class: "p-button-success",
                  icon: "pi pi-send",
                  onClick: _ctx.submit,
                  disabled: !_ctx.isValid && false,
                  label: _ctx.$t('form.submit')
                }, null, 8, ["onClick", "disabled", "label"])
              ])
            ])
          ]))
    ])
  ], 64))
}